export default __webpack_public_path__ + "static/media/porcentagem.0188e167.svg";